export const MODULO_LABELS = {
  inicio: 'Inicio',
  clientes: 'Clientes',
  productos: 'Productos o Servicios',
  conceptos: 'Conceptos',
  exportacion: 'Exportación',
  importacion: 'Importación',
  servicios_acordados: 'Servicios acordados',
  cotizaciones_eliminadas: 'Cotizaciones eliminadas',
  agenda_reuniones: 'Agenda de reuniones',
  curriculums: 'Curriculums',
  localidades: 'Localidades',
  usuarios: 'Usuarios y roles',
};

export const ACCION_LABELS = {
  ver: 'Ver',
  crear: 'Crear',
  editar: 'Editar',
  eliminar: 'Eliminar',
};
